import InfoSvg from "@/public/icons/16px/Info.svg";
import clsx from "clsx";
import styles from "./cart-notification.module.css";
export type CartNotificationTypes = "info" | "error";

export interface CartNotificationProps {
  type: CartNotificationTypes;
  message: React.JSX.Element | string;
  show?: boolean;
  reset?: () => void;
}

const CartNotification = ({
  type,
  message,
  show = true,
  reset,
}: CartNotificationProps): React.JSX.Element => {
  if (!show) return <></>;
  return (
    <div
      className={clsx(
        styles["cart-notification"],
        styles[`cart-notification-${type}`]
      )}
    >
      <span className={styles.icon}>
        <InfoSvg />
      </span>
      <p className={styles.message}>
        {message}{" "}
        {reset && (
          <button className={styles.resetButton} onClick={reset}>
            Prøv igjen
          </button>
        )}
      </p>
    </div>
  );
};

export default CartNotification;
